import { render, staticRenderFns } from "./FormPoll.vue?vue&type=template&id=488fb7bc&scoped=true&"
import script from "./FormPoll.vue?vue&type=script&lang=js&"
export * from "./FormPoll.vue?vue&type=script&lang=js&"
import style0 from "./FormPoll.vue?vue&type=style&index=0&id=488fb7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fb7bc",
  null
  
)

export default component.exports